export default __webpack_public_path__ + "static/media/VO_QUESTION_MARK.836decf2.svg";